import { useCallback, useMemo } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";

import { useApi } from "shared/services/api/useApi";
import { useParams } from "react-router";

const useClientLOBs = () => {
    const { getDataAsync, putData, postData, deleteData } = useApi();
    const queryClient = useQueryClient();
    const { clientId } = useParams();

    const getClientLOBsApiCall = useCallback(async () => {
        const response = await getDataAsync("getLOBbyClientId", {
            urlParams: [{ name: "$clientId", value: clientId }],
        });

        const result = response.status === 204
            ? null
            : response.json();

        return result;

    }, [getDataAsync, clientId]);

    const clientLOBs = useQuery("clientLOBsList", getClientLOBsApiCall);

    const createClientLOBApiCall = useCallback(
        ({ clientLOBId, body }) => {
            return postData("updateLOBbyClientId", {
                urlParams: [{ name: "$clientLOBId", value: clientLOBId }],
                body,
            });
        },
        [postData]
    );

    const updateClientLOBApiCall = useCallback(
        ({ clientLOBId, body }) => {
            return putData("updateLOBbyClientId", {
                urlParams: [{ name: "$clientLOBId", value: clientLOBId }],
                body,
            });
        },
        [putData]
    );

    const deleteClientLOBApiCall = useCallback(
        ({ clientLOBId }) => {
            return deleteData("deleteLOBbyClientId", {
                urlParams: [{ name: "$id", value: clientLOBId }],
            });
        },
        [deleteData]
    );

    const mutationOptions = useMemo(() => {
        return {
            onSuccess: () => {
                queryClient.invalidateQueries("clientLOBsList");
            },
        };
    }, [queryClient]);

    const createClientLOB = useMutation(
        createClientLOBApiCall,
        mutationOptions
    );
    const updateClientLOB = useMutation(
        updateClientLOBApiCall,
        mutationOptions
    );
    const deleteClientLOB = useMutation(
        deleteClientLOBApiCall,
        mutationOptions
    );

    return useMemo(() => {
        return {
            clientLOBs,
            createClientLOB,
            updateClientLOB,
            deleteClientLOB,
        };
    }, [clientLOBs, createClientLOB, updateClientLOB, deleteClientLOB]);
};

export default useClientLOBs;
